var path = 'components/streams/views/setrixServerSettings.html';
var html = "<div class=\"animated slideRightNice\"> <div ng-include=\"'components/packages/views/addPackage.setrixServerSettings.html'\"></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;